import React from 'react';
import classnames from 'classnames';

var styles = {"base":"asDB9Ra2UpA-"};

var fontSizes = {"extravagant":"_7C4Ck1izBPs-","jumbo":"_8X-fSrUTxV8-","largest":"n-SPJXPXLSA-","larger":"vCrvF55YQ9o-","large":"FBoaHWotSik-","base":"V6yPPLHLeuY-","small":"T5XC4DgJlxk-","smaller":"sycqXMMO-wc-"};

var fontWeights = {"regular":"lziyWzzvuno-","medium":"PVKSijyipP8-","semiBold":"-ch9Z4gIGDg-","bold":"EEwS0f07RqQ-","extraBold":"kA3NtPPWbP0-","black":"_3M58OLqp0JM-"};

var textCases = {"uppercase":"xE6cC62h5G0-","lowercase":"HlqJJ3Cl7dE-","capitalize":"Loe26JnDfco-","none":"Gv3bg8ZDlAY-"};

var textColors = {"blue":"pkqoq2KXY9w-","grey":"ftVHRSii3ro-","greyBlueDark":"FQbGABZWVzA-","greyBlue":"zQaB9J0-vrs-","green":"_4-xdzcqT-Us-","red":"Zp9E7ELPjPA-","yellow":"v-Fo4PwPxDI-","yellowDark":"YrGUIChAZC0-","lightBlue":"r7JcIVoDcTY-","white":"_6RXTyd198iM-","heading":"fLix4jA-RkU-","text":"_1g0uMAwFAsk-","textSecondary":"oXqFAHwT6y4-","inactive":"gPhKMwPfrsw-","critical":"rWkzi9HFNDU-","warning":"PQLYQKGCmPI-","informative":"L6bBDJrx-m0-","success":"bJDJJKvmT90-","interactive":"_99f--2dY5rg-","disabled":"_3g4iYm8XwkM-"};

var emphasis = {"italic":"Jys1uy2pQXw-","highlight":"kd2u0dL-if0-"};

var truncate = {"textTruncate":"LUJEfdi3pws-"};

var alignment = {"start":"eDMsbRCP0kg-","center":"j34R9yIG--c-","end":"CeI75T5sHwM-"};

var fontFamilies = {"base":"mRpfVoMiIMM-","display":"TPtuWMdOsfw-"};

/* eslint-disable import/no-internal-modules */
function Typography({ id, children, element: Tag = "p", size, align, fontWeight = "regular", textCase, textColor, emphasisType, numberOfLines, fontFamily, }) {
    const shouldTruncateText = numberOfLines && numberOfLines > 0;
    const className = classnames(styles.base, fontWeights[fontWeight], size && fontSizes[size], textCase && textCases[textCase], textColor && textColors[textColor], emphasisType && emphasis[emphasisType], fontFamily && fontFamilies[fontFamily], shouldTruncateText && truncate.textTruncate, Object.assign({}, (align && { [alignment[align]]: align !== `start` })));
    let truncateLines;
    if (shouldTruncateText) {
        truncateLines = {
            WebkitLineClamp: numberOfLines,
            WebkitBoxOrient: "vertical",
        };
    }
    return (React.createElement(Tag, { id: id, className: className, style: truncateLines }, children));
}

export { Typography as T };
